import React from "react";
import { useState } from "react";
import ScrollSnapBox from "../ScrollSnapBox";
import ContactImage from "../../assets/images/contact-bg.jpg";

const ContactForm = () => {
  const [email, setEmail] = useState("");
  // const [address, setAddress] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault(); // Avoid page refresh

    const recipient = "info@duralyze.com"; 
    const subject = encodeURIComponent("Contact Form Submission"); 
    const body = encodeURIComponent(
      `Hello,\n\nI would like to get in touch.\n\nEmail: ${email}\n\nBest regards.`
    ); 

    // Generate the mailto link
    const mailtoLink = `mailto:${recipient}?subject=${subject}&body=${body}`;

    // Open the mail client
    window.location.href = mailtoLink;
  };

  return (
    <ScrollSnapBox>
      {({ inView }) => (
        <div
          className="w-full px-6 sm:px-8 md:px-10 lg:px-20 my-16 sm:my-20 md:my-24 lg:my-36"
          style={{
            opacity: inView ? 1 : 0,
            transform: `translateY(${inView ? "0" : "30px"})`,
            transition: "all 1000ms ease-out",
          }}
        >
          <div className="w-full relative overflow-hidden p-8 md:p-12 mb-8 lg:mb-0 lg:mr-8">
            <img
              src={ContactImage}
              alt="Duralyze Team Background"
              className="absolute inset-0 w-full h-full object-cover object-center"
            />
            {/* Cover Layer */}
            <div className="absolute inset-0 bg-black opacity-50" />
            {/* Contact Content */}
            <div className="relative z-10 max-w-xl">
              <h2 className="text-center text-2xl md:text-3xl lg:text-5xl font-bold text-white p-4 md:p-8">
                Contact Us
              </h2>
              <p className="text-base sm:text-lg md:text-xl text-white px-4 md:px-16 mb-4 md:mb-8">
                Join us in the journey of achieving green energy
              </p>
              <form onSubmit={handleSubmit}>
                <div className="px-4 md:px-16 flex items-center mb-8">
                  <label
                    htmlFor="email"
                    className="w-1/4 md:w-1/5 text-white text-xs sm:text-sm md:text-base font-medium"
                  >
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={email}
                    aria-required="true" // Accessibility
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-3/4 md:w-4/5 p-2 border text-xs sm:text-sm md:text-base focus:outline-none focus:ring-2 focus:ring-blue-400"
                    placeholder="Enter your email"
                    required
                  />
                </div>
                {/* <div className="px-4 md:px-16 flex items-center mb-8">
                  <label
                    htmlFor="address"
                    className="w-1/4 md:w-1/5 text-white text-xs sm:text-sm md:text-base font-medium"
                  >
                    Address
                  </label>
                  <input
                    type="text"
                    id="address"
                    name="address"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    className="w-3/4 md:w-4/5 p-2 border text-xs sm:text-sm md:text-base focus:outline-none focus:ring-2 focus:ring-blue-400"
                    placeholder="Enter your address"
                    required
                  />
                </div> */}

                {/* Submit */}
                <div className="px-4 md:px-16">
                  <button
                    type="button" 
                    onClick={handleSubmit} // Call the function when clicked
                    className="md:w-36 text-sm sm:text-base md:text-xl text-white px-4 py-2 border border-white hover:bg-white hover:text-gray-700 mb-8 transition"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </ScrollSnapBox>
  );
};

export default ContactForm;
